import { useMutation, useQueryClient } from '@tanstack/react-query'
import { companyDetailKey } from './keys'
import { CompanyDetail } from 'api/company/companyDetail'
import { setChargeUpfront } from 'api/company/setChargeUpfront'

export const useSetCompanyChargeUpfrontMutation = (companyId: number) => {
  const queryClient = useQueryClient()
  return useMutation({
    mutationFn: (
      request: Omit<Parameters<typeof setChargeUpfront>[0], 'companyId'>
    ) =>
      setChargeUpfront({
        ...request,
        companyId,
      }),
    onMutate: async (request) => {
      await queryClient.cancelQueries({ queryKey: companyDetailKey(companyId) })

      const previousCompanyDetail = queryClient.getQueryData(
        companyDetailKey(companyId)
      )

      queryClient.setQueryData<CompanyDetail>(
        companyDetailKey(companyId),
        (old) => {
          if (!old) return old

          let paymentMethod = old.paymentMethod
          if (request.chargeUpfront === false) {
            paymentMethod = 'invoice'
          } else if (
            request.chargeUpfront === true &&
            old.paymentMethod === 'invoice'
          ) {
            paymentMethod = undefined
          }

          return {
            ...old,
            paymentMethod,
            invoiceDueDays: request.invoiceDueDays ?? old.invoiceDueDays,
          }
        }
      )

      return { previousCompanyDetail }
    },
    onError: (_error, _, context) => {
      queryClient.setQueryData(
        companyDetailKey(companyId),
        context?.previousCompanyDetail
      )
    },
    onSettled: () => {
      queryClient.invalidateQueries({ queryKey: companyDetailKey(companyId) })
    },
  })
}
